// App Bridge v4 auto-configures when running inside the Shopify admin iframe.
// No explicit Provider wrapper is required for v4+.
// Add @shopify/app-bridge-react hooks (useAppBridge, TitleBar, etc.) directly in
// any component that needs App Bridge features.

type Props = { children: React.ReactNode }

export function AppBridgeProvider({ children }: Props) {
  return <>{children}</>
}
